import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Bitcoin, ShieldCheck } from "lucide-react";
import { api, errMsg, fmtFiat } from "@/lib/api";

export default function Store() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/v1/store/${slug}`).then((r) => setS(r.data)).catch((e) => setErr(errMsg(e))); }, [slug]);

  if (err) return <div className="min-h-screen grid place-items-center text-zinc-400 text-sm" data-testid="store-error">{err}</div>;
  if (!s) return <div className="min-h-screen grid place-items-center text-zinc-500 text-sm">Chargement…</div>;

  return (
    <div className="min-h-screen px-4 sm:px-8 py-10 max-w-5xl mx-auto fade-up" data-testid="store-page">
      <header className="flex items-start justify-between gap-4 mb-10">
        <div>
          <div className="flex items-center gap-2 mb-3"><span className="h-9 w-9 rounded-md bg-amber-500 grid place-items-center text-zinc-950"><Bitcoin size={20} strokeWidth={2.5} /></span><span className="eyebrow">Boutique Bitcoin</span></div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="store-merchant-name">{s.merchantName}</h1>
          {s.description && <p className="text-sm text-zinc-400 mt-3 max-w-xl leading-relaxed" data-testid="store-description">{s.description}</p>}
        </div>
        {s.mode === "test" && <span className="text-[10px] font-mono px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/30">TESTNET</span>}
      </header>
      {s.products.length === 0 ? <div className="text-sm text-zinc-500" data-testid="store-empty">Aucun produit disponible pour le moment.</div> : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="store-products">
          {s.products.map((p) => (
            <div key={p.paySlug} className="panel overflow-hidden flex flex-col hover:border-amber-500/40 transition-colors" data-testid="store-product-card">
              {p.imageUrl ? <img src={p.imageUrl} alt={p.name} className="h-44 w-full object-cover" data-testid="store-product-image" /> : <div className="h-20 w-full bg-gradient-to-br from-zinc-800 to-zinc-900 grid place-items-center text-zinc-600"><Bitcoin size={22} /></div>}
              <div className="p-5 flex flex-col flex-1">
              <h2 className="text-lg font-semibold tracking-tight" data-testid="store-product-name">{p.name}</h2>
              {p.description && <p className="text-xs text-zinc-400 mt-2 leading-relaxed line-clamp-3">{p.description}</p>}
              <div className="mt-auto pt-5 flex items-center justify-between">
                <span className="font-heading font-bold text-xl" data-testid="store-product-price">{fmtFiat(p.price, p.currency)}</span>
                {p.inStock ? <Link to={`/pay/${p.paySlug}`} className="px-4 py-2 rounded-md bg-amber-500 hover:bg-amber-400 text-zinc-950 text-sm font-semibold transition-colors active:scale-95" data-testid="store-buy-link">Acheter</Link>
                  : <span className="text-xs text-red-400" data-testid="store-out-of-stock">Rupture</span>}
              </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <footer className="mt-12 flex items-center gap-2 text-[11px] text-zinc-600"><ShieldCheck size={12} /> Paiements Bitcoin non-custodiaux · e-mail vérifié · codes livrés après confirmation</footer>
    </div>
  );
}
